<p-button
  class="help-button"
  styleClass="!rounded-[50px]"
  [style.inset-inline-end]="helpButtonPositionerService.insetEnd() + 'px'"
  (click)="helpContainer.toggle($event)"
>
  <i class="icon icon-help-circle text-lg"> </i>
  <span> {{ "labels.HELP" | translate }} </span>
</p-button>

<p-popover
  #helpContainer
  [dismissable]="false"
  appendTo="body"
  styleClass="help-popover"
>
  <app-help-and-documentation-container (close)="helpContainer.hide()" />
</p-popover>
